import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router";
import { Stack } from "@mui/material";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
// const products = [
//   {
//     id: 1,
//     title: "Red Sabyasachi Bridal Lehenga ",
//     image: "https://thesoyara.com/app/uploads/5/83067.jpeg",
//     price: "₹4500.00",
//     product_id: 5,
//   },
//   {
//     id: 2,
//     title: "Off White Bridal",
//     image: "https://thesoyara.com/app/uploads/230/33089.jpeg",
//     price: "₹5500.00",
//     product_id: 230,
//   },
//   {
//     id: 3,
//     title: "Black Full Sleeves Ball Gown",
//     image: "https://thesoyara.com/app/uploads/10/23690.jpeg",
//     price: "₹3999.00",
//     product_id: 10,
//   },
//   {
//     id: 4,
//     title: "Purple Golden Work Heavy Lehenga",
//     image: "https://thesoyara.com/app/uploads/305/68124.jpeg",
//     price: "₹5500.00",
//     product_id: 305,
//   },
// ];

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

function FeaturedProducts() {
  let navigation = useNavigate();
  const [products, setProducts] = useState([]);
  const [imgPath, setImgPath] = useState();
  const [noImgPath, setNoImgPath] = useState();
  const [loading, setLoading] = useState(false);

  async function getFeatchedProduct() {
    setLoading(true);
    try {
      let response = await fetch(
        "https://thesoyara.com/app/index.php?r=api/item-list&display_cat=1&page_limit=4",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let result = await response.json();
      if (result?.item_master?.length > 0) {
        setProducts(result.item_master);
      }
      setImgPath(result.image_def_path);
      setNoImgPath(result.no_image_path);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getFeatchedProduct();
  }, []);

  return (
    <section className="featured-section">
      <h2 className="section-title">Featured Products</h2>
      <motion.div
        className="product-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
      >
        {loading ? (
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ width: "100%" }}
          >
            <DotLottieReact
              src="https://lottie.host/e5599654-39d1-4cac-aef5-1c2c4a5af8ca/bTMlPQbvw8.lottie"
              loop
              autoplay
              style={{ width: "60px", height: "60px" }}
            />
          </Stack>
        ) : (
          products.map((product) => (
            <motion.div
              key={product.id}
              className="product-card"
              variants={itemVariants}
              onClick={() => navigation(`/product_details/${product.id}`)}
            >
              <img
                src={product.images ? `${imgPath}${product.images}` : noImgPath}
                alt={product.name}
                className="product-img"
                lazyLoad="lazy"
              />
              <h3 className="product-title">{product.name}</h3>
              {/* <p className="product-price">{product.price}</p> */}
            </motion.div>
          ))
        )}
      </motion.div>
    </section>
  );
}

export default FeaturedProducts;
